import { Button, Input, Modal, Spin, Typography } from 'antd';
import Title from 'antd/es/typography/Title';
import React, { useEffect, useState } from 'react';
import { ADD_USER_INITIAL_OBJECT } from '../../screens/admin/userManagement/UserManagementUtils';
import { UserProfileAPI } from '../../API/UserProfileAPI';
const { Text } = Typography;

function EditProfile({ open, setOpen, messageToast }) {
    const [inputElements, setInputElements] = useState(ADD_USER_INITIAL_OBJECT);
    const [loadSpin, setLoadSpin] = useState(false)

    function backFun() {
        setInputElements(ADD_USER_INITIAL_OBJECT)
        setOpen(false)
    }

    function handleChange(value, name) {
        let error = '';

        if (!value.trim()) {
            error = 'Field is required';
        } else if (value.trim().length >= 100) {
            error = 'MAX length 100!';
        }

        setInputElements(prev => ({
            ...prev,
            [name]: value,
            errorMessage: {
                ...prev.errorMessage,
                [name]: error
            }
        }))
    }

    async function addFun() {
        if (formValidation()) {
            setLoadSpin(true)
            const bodyData = {
                first_name: inputElements.firstName,
                last_name: inputElements.lastName
            }
            await UserProfileAPI.postUpdateProfile(bodyData)
                .then(res => {
                    if (res.data.status === true) {
                        localStorage.setItem("user-first-name", bodyData.first_name)
                        localStorage.setItem("user-last-name", bodyData.last_name)
                        setLoadSpin(false)
                        setInputElements(ADD_USER_INITIAL_OBJECT);
                        messageToast("success", res.data?.message);
                        setOpen(false)
                    } else {
                        messageToast('error', res?.message);
                        setLoadSpin(false)
                    }
                })
                .catch(() => {
                    messageToast('error', "Internal Server Error");
                    setLoadSpin(false)
                })
        }
    }

    function formValidation() {
        let isValid = false;
        let obj = { ...inputElements }

        obj.errorMessage = {
            ...inputElements.errorMessage,
            firstName: !inputElements.firstName ? "Field is required" : inputElements.firstName.trim().length >= 100 ? "MAX length 100!" : "",
            lastName: !inputElements.lastName ? "Field is required" : inputElements.lastName.trim().length >= 100 ? "MAX length 100!" : "",
        }

        setInputElements(obj);

        if (obj.firstName && !obj.errorMessage.firstName &&
            obj.lastName && !obj.errorMessage.lastName) {
            isValid = true
        }

        return isValid;
    }

    useEffect(() => {
        if (open) {
            setInputElements({
                ...ADD_USER_INITIAL_OBJECT,
                firstName: localStorage.getItem("user-first-name"),
                lastName: localStorage.getItem("user-last-name"),
            })
        }
    }, [open])

    return (
        <Modal
            open={open}
            okText='Apply'
            cancelText='Clear All'
            onCancel={() => backFun()}
            footer={[
                <Button key="back" type='text' onClick={backFun}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={addFun}
                >
                    Save
                </Button>
            ]}
        >
            <Spin spinning={loadSpin}>
                <div style={{ padding: '10px' }}>
                    <div style={{ marginBottom: '20px', borderBottom: 'solid 1px #80808047' }}>
                        <Title level={5}>Update Profile</Title>
                    </div>

                    <div style={{ gap: 10 }}>
                        <div style={{ marginBottom: '15px', }}>
                            <label>First Name</label>
                            <Input status={inputElements.errorMessage.firstName === "" ? '' : 'error'} value={inputElements.firstName}
                                onChange={(e) => handleChange(e.target.value.trimStart(), 'firstName')}
                            />
                            <Text type="danger" italic>{inputElements.errorMessage.firstName}</Text>
                        </div>
                        <div style={{ marginBottom: '15px', }}>
                            <label>Last Name</label>
                            <Input status={inputElements.errorMessage.lastName === "" ? '' : 'error'} value={inputElements.lastName}
                                onChange={(e) => handleChange(e.target.value.trimStart(), 'lastName')}
                            />
                            <Text type="danger" italic>{inputElements.errorMessage.lastName}</Text>
                        </div>
                    </div>
                </div>
            </Spin>
        </Modal>
    )
}

export default EditProfile